import { useQuery } from '@tanstack/react-query';
import apiClient from '@shared/lib/apiClient';
export const useTelegramStatus = () => useQuery({
    queryKey: ['telegram', 'status'],
    queryFn: async () => {
        const { data } = await apiClient.get('/telegram/health');
        return data;
    },
    staleTime: 1000 * 30,
    retry: 1,
});
